import R from 'ramda';
import React, { Component } from 'react';
import { Row, Col, FormGroup, FormControl, Radio } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import getContent from '../ContractBlock/Contents/Credit';
import ChangeRequestsView from '../Deals/DealEditPages/ChangeRequestsView';

export default class Credit extends Component {
  constructor(props) {
    super(props);
    this.state = { adjust: undefined, changes: {} };
  }

  options = () => ({
    field1: this.state.changes.field1,
    field2: this.state.changes.field2,
  });

  componentDidMount() {
    if (this.props.dealBlocks) {
      this.getBlockChanges(this.props.dealBlocks);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dealBlocks) {
      this.getBlockChanges(nextProps.dealBlocks);
    }
  }

  getBlockChanges(dealBlocks) {
    const block = R.find(R.propEq('id', this.props.block.id))(dealBlocks);
    if (block) {
      this.setState({
        changes: block.changes || {},
        adjust: block.accept ? !block.accept : block.changes ? true : undefined,
      });
    }
  }

  handleAdjust(adjust) {
    this.setState({ adjust });

    if (!adjust) {
      this.props.removeBlockChanges(this.props.block.id);
    }
  }

  handleContent(index) {
    const options = this.options();

    options.field1 = index;
    this.props.setBlockChanges({
      id: this.props.block.id,
      options,
      ...getContent(options),
    });
  }

  handleOtherContent(e) {
    const options = this.options();

    options.field2 = e.target.value;
    this.props.setBlockChanges({
      id: this.props.block.id,
      options,
      ...getContent(options),
    });
  }

  renderOriginal() {
    if (this.props.field1 === 0) {
      return `A credit is not required, but may be provided at the content owner’s discretion.`;
    } else if (this.props.field1 === 1) {
      return `A credit will be given to this Contributor only if others in similar roles are given credit too.
        Each person playing a similar role will receive the same credit.
        (For example, if two collaborators contribute as writers, each will be given credit as a “Writer” or “Co-writer” of the work in the same size, placement, and prominence.)`;
    } else if (this.props.field1 === 2) {
      return this.props.field2;
    }

    return null;
  }

  renderAdjust() {
    const { adjust, changes } = this.state;

    if (adjust === true) {
      return (
        <div className="inner-content">
          <FormGroup className="answer">
            <Radio
              name="credit"
              checked={changes.field1 === 0}
              readOnly
              onClick={(e) => this.handleContent(0)}
            >
              A credit is not required, but may be provided at the content
              owner’s discretion.
            </Radio>
            <Radio
              name="credit"
              checked={changes.field1 === 1}
              readOnly
              onClick={(e) => this.handleContent(1)}
            >
              A credit will be given to this Contributor only if others in
              similar roles are given credit too. Each person playing a similar
              role will receive the same credit. (For example, if two
              collaborators contribute as writers, each will be given credit as
              a “Writer” or “Co-writer” of the work in the same size, placement,
              and prominence.)
            </Radio>
            <Radio
              name="credit"
              checked={changes.field1 === 2}
              readOnly
              onClick={(e) => this.handleContent(2)}
            >
              A credit will be provided to this Contributor for their
              contribution.
            </Radio>
            {changes.field1 === 2 ? (
              <FormGroup className="answer">
                <FormControl
                  type="text"
                  placeholder="enter the credit to be provided here (e.g. Produced by Johnny Jay)"
                  value={changes.field2}
                  onChange={(e) => this.handleOtherContent(e)}
                />
              </FormGroup>
            ) : null}
          </FormGroup>
        </div>
      );
    } else {
      return null;
    }
  }

  renderChangeRequest(changeRequest) {
    if (changeRequest.changes.field1 === 0) {
      return `A credit is not required, but may be provided at the content owner’s discretion.`;
    } else if (changeRequest.changes.field1 === 1) {
      return `A credit will be given to this Contributor only if others in similar roles are given credit too.
                    Each person playing a similar role will receive the same credit.
                    (For example, if two collaborators contribute as writers, each will be given credit as a “Writer” or “Co-writer” of the work in the same size, placement, and prominence.)`;
    } else if (changeRequest.changes.field1 === 2) {
      return changeRequest.changes.field2;
    }

    return `None`;
  }

  renderChangeRequests() {
    return (
      <ChangeRequestsView
        changeRequests={this.props.changeRequests}
        renderChangeRequest={(changeRequest) =>
          this.renderChangeRequest(changeRequest)
        }
        isHTML
      />
    );
  }

  render() {
    return (
      <div className="tab-content">
        <Row>
          {!this.props.finalized && !this.props.isAttorney && (
            <Col sm={12}>
              <div className="questions">
                <p className="question">
                  Will a credit be provided to the contributor for their
                  contribution?
                </p>
                <FormGroup className="answer">
                  <Radio
                    name="credit-adjust"
                    checked={this.state.adjust === false}
                    readOnly
                    onClick={(e) => this.handleAdjust(false)}
                  >
                    {this.props.userInfo.same
                      ? `Keep my original proposal: `
                      : `Accept ${this.props.userInfo.name} 's proposed terms: `}
                    {this.renderOriginal()}
                  </Radio>
                  <hr />
                  <Radio
                    name="credit-adjust"
                    checked={this.state.adjust === true}
                    readOnly
                    onClick={(e) => this.handleAdjust(true)}
                  >
                    {this.props.userInfo.same
                      ? `Change my proposal:`
                      : `Suggest an alternative:`}
                  </Radio>
                </FormGroup>
                {this.renderAdjust()}
                {this.props.renderAccepts()}
                {this.renderChangeRequests()}
              </div>
            </Col>
          )}
          {!this.props.finalized && !this.props.isAttorney && (
            <Col sm={12}>{this.props.children}</Col>
          )}

          <Col sm={12}>
            <div className="notes">
              <h4>
                <FontAwesome name="question-circle" />
                Need Some Help?
              </h4>
              <div className="expand" tabIndex="0">
                <p className="question">Why is this important?</p>
                <p className="small">
                  A credit acknowledges a Contributor for their contribution to
                  the work(s) (e.g. written by, produced by, directed by, etc.).
                  Providing credit to a contributor can include publicly listing
                  their name, likeness, logos, trademarks, biographical
                  information, and their role in the creation of the work(s).
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/components/DealContractBlock/Credit.jsx